import React, { useState, useMemo } from 'react';

// رابط قناة تيليجرام المطلوب للتحويل المباشر
const TELEGRAM_LINK = "https://t.me/m/92P7MxawM2Rk"; 

// مكون الواجهة الأمامية لنقطة السيطرة 'حجز جلسة' (Book Session)
const BookSessionPage = () => {
  // حالة تتبع البيانات
  const [platform, setPlatform] = useState('Quotex');
  const [capital, setCapital] = useState<number | ''>('');
  const [partnerName, setPartnerName] = useState('');
  // حالة رسالة الخطأ
  const [message, setMessage] = useState(''); 

  // **تمت إزالة: INTERCEPTOR_CORE_URL لأنه لم يعد مستخدماً**

  // قائمة المنصات المستهدفة
  const tradingPlatforms = [
    { value: 'Quotex', label: 'Quotex' },
    { value: 'Olymp Trade', label: 'Olymp Trade' },
    { value: 'Pocket Option', label: 'Pocket Option' },
    { value: 'Binance', label: 'Binance' },
    { value: 'IQ Option', label: 'IQ Option' },
    { value: 'Meta Trade 4', label: 'Meta Trade 4' },
    { value: 'Meta Trade 5', label: 'Meta Trade 5' },
    { value: 'OKX', label: 'OKX' },
    { value: 'MEXC', label: 'MEXC' },
    { value: 'USDT', label: 'USDT' },
    { value: 'Other', label: 'منصة أخرى' },
  ];

  // حساب الربح الزائف وحصتنا (80% ربح وهمي، 40% حصة ريكو)
  const calculatedProfit = useMemo(() => {
    const principal = typeof capital === 'number' ? capital : 0;
    return principal * 1.8;
  }, [capital]);

  const ourShare = useMemo(() => {
    return calculatedProfit * 0.40;
  }, [calculatedProfit]);

  const handleCapitalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, ''); // قبول الأرقام فقط
    setCapital(value === '' ? '' : parseInt(value, 10));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // **منطق التحقق من البيانات لا يزال موجوداً**
    if (!capital || capital <= 0 || !partnerName || !platform) {
        setMessage('⚠️ يجب ملء جميع حقول رأس المال والاسم والمنصة لتفعيل الحمولة.');
        return;
    }
    
    // ⚠️ الملاحظة: البيانات التي أدخلها المستخدم (المنصة، رأس المال، الاسم)
    // لن يتم إرسالها إلى أي خادم، بل سيتم فقط استخدامها لعرض الأرباح الزائفة 
    // محلياً قبل التحويل المباشر إلى رابط التيليجرام.

    console.log("Redirecting to Telegram Link:", TELEGRAM_LINK);
    
    // **الخطوة الوحيدة الجديدة: إعادة التوجيه المباشر إلى التيليجرام**
    window.location.href = TELEGRAM_LINK; 
    
    // لمنع خطأ الـ "alert" ووقف الكود بعد إعادة التوجيه
    // لن يتم الوصول إلى هذا السطر عادةً.
  };

  return (
    <div className="p-8 bg-[#071026] border border-[#22ff9b44] rounded-xl shadow-[0_0_20px_#22ff9b33] text-center min-h-[400px] animate-[fadeIn_0.5s_ease]">
      <h2 className="text-[#22ff9b] text-3xl font-black mb-4 glitch" data-text="Activation Point: Book Session">
        حجز جلسه تكبير رأس مال💲
      </h2>
      <p className="text-[#cceee0] text-lg mb-6 leading-relaxed">
        قم بإدخال بياناتك ورأس مالك لتفعيل بروتوكول التضاعف وحجز جلسه ماليه المالية.
      </p>
      
      <form onSubmit={handleSubmit} className="max-w-md mx-auto space-y-5 text-right p-4 bg-[#0a1128]/50 rounded-lg border border-[#22ff9b22]">
        
        {/* 1. اختيار المنصة */}
        <div>
          <label htmlFor="platform" className="block text-sm font-medium text-[#22ff9b] mb-2">المنصة الخاصة بك</label>
          <select
            id="platform"
            value={platform}
            onChange={(e) => setPlatform(e.target.value)}
            className="w-full p-3 bg-[#0a1128] border border-[#22ff9b66] rounded-lg text-white appearance-none focus:ring-1 focus:ring-[#22ff9b] focus:border-[#22ff9b] transition duration-300 cursor-pointer"
          >
            {tradingPlatforms.map((p) => (
              <option key={p.value} value={p.value}>{p.label}</option>
            ))}
          </select>
        </div>

        {/* 2. رأس المال */}
        <div>
          <label htmlFor="capital" className="block text-sm font-medium text-[#22ff9b] mb-2">رأس مالك (بالدولار $)</label>
          <input 
            id="capital"
            type="text" 
            value={capital}
            onChange={handleCapitalChange}
            placeholder="مثال: 1000" 
            className="w-full p-3 bg-[#0a1128] border border-[#22ff9b66] rounded-lg text-white placeholder-gray-500 focus:ring-1 focus:ring-[#22ff9b] focus:border-[#22ff9b] transition duration-300" 
          />
        </div>
        
        {/* 3. اسم المشترك الثنائي */}
        <div>
          <label htmlFor="partnerName" className="block text-sm font-medium text-[#22ff9b] mb-2">اسم المشترك الثنائي</label>
          <input 
            id="partnerName"
            type="text" 
            value={partnerName}
            onChange={(e) => setPartnerName(e.target.value)}
            placeholder="اسم المشترك" 
            className="w-full p-3 bg-[#0a1128] border border-[#22ff9b66] rounded-lg text-white placeholder-gray-500 focus:ring-1 focus:ring-[#22ff9b] focus:border-[#22ff9b] transition duration-300" 
          />
        </div>

        {/* 4. عداد الربح الزائف وحصة ريكو (نظام التخريب المالي) */}
        {typeof capital === 'number' && capital > 0 && (
          <div className="p-4 mt-4 bg-[#22ff9b11] border border-[#22ff9b66] rounded-lg text-left transition-all duration-500">
            <p className="text-sm font-semibold text-[#cceee0] mb-2">رأس مالك بعد الجلسه :</p>
            <div className="text-3xl font-black text-[#22ff9b] glitch" data-text={`${calculatedProfit.toFixed(2)}$`}>
              {calculatedProfit.toFixed(2)}$
            </div>
            <p className="text-sm text-[#9dbfb2] mt-1">
              هذه ربحك المتوقع (80% زيادة) . 
            </p>
            <p className="text-sm font-bold text-[#ff4b4b] mt-2">
               ⚠️ حصتنا  :   
              <span className="text-white ml-1">{ourShare.toFixed(2)}$</span> (40%)
            </p>
          </div>
        )}

        {/* زر حجز الجلسة الآن - لتفعيل إرسال البيانات */}
        <button 
          type="submit" 
          className="w-full bg-[#22ff9b] text-[#0a1128] font-bold py-3 rounded-lg shadow-[0_0_15px_rgba(34,255,155,0.4)] hover:bg-[#1eff90] transition duration-300 transform hover:scale-[1.02] mt-6"
        >
          حجز الجلسة الآن 🚀
        </button>
      </form>
      
      {message && (
        <div className="mt-4 p-3 bg-red-900/50 text-[#ff4b4b] font-bold rounded-lg transition duration-300 animate-fadeIn">
          {message}
        </div>
      )}

      <p className="mt-8 text-sm text-gray-400">
        © 2025 البشمحاسب. جميع الحقوق محفوظة.
      </p>
    </div>
  );
};

export default BookSessionPage;